import { useTranslation } from 'react-i18next';
import {
  DeleteIconButton,
  EditIconButton,
  Icon,
  Page,
  SimpleIconButton,
} from '@/components';
import { useNavigate, useParams } from 'react-router-dom';
import { useGetArticleDetailsQuery } from '@/redux/articles';
import {
  ArticleDetailsPanel,
  useDeleteArticleAction,
  useUpdateArticleStatusAction,
} from '@/views/Articles.Details';
import { Space } from 'antd';
import { EyeInvisibleOutlined, RocketOutlined } from '@ant-design/icons';
import { ArticleStatus } from '@/core/http.articles';

const useId = () => {
  const params = useParams<'id'>();
  return params.id!;
};

export function ArticleDetailsPage() {
  const { t } = useTranslation();
  const id = useId();

  const { data } = useGetArticleDetailsQuery({ id });
  const title = data?.title ?? t('fetchFallbackTitle');
  const push = useNavigate();

  const { deleteAction } = useDeleteArticleAction({
    onSuccess: () => {
      push(-1);
    },
  });

  const { publishAction, hideAction } = useUpdateArticleStatusAction();

  return (
    <Page htmlTitle={title}>
      <Page.Paths>
        <Page.Path href="/admin#articles">{t('articles.title')}</Page.Path>
        <Page.Path>{title}</Page.Path>
      </Page.Paths>

      <Page.Body>
        <Page.Card
          title={title}
          icon={<Icon type="article" />}
          color="#814A93"
          actions={
            <Space>
              <EditIconButton
                onClick={() => {
                  push(`/admin/articles/${id}/edit`);
                }}
              />
              <DeleteIconButton
                onClick={() => {
                  deleteAction(id);
                }}
              />
              {data?.status !== ArticleStatus.Published && (
                <SimpleIconButton
                  iconButton={<RocketOutlined />}
                  action={t('articles.action.publish')}
                  onClick={() => {
                    publishAction(id);
                  }}
                />
              )}
              {data?.status === ArticleStatus.Published && (
                <SimpleIconButton
                  iconButton={<EyeInvisibleOutlined />}
                  action={t('articles.action.hide')}
                  onClick={() => {
                    hideAction(id);
                  }}
                />
              )}
            </Space>
          }
        >
          <ArticleDetailsPanel id={id} />
        </Page.Card>
      </Page.Body>
    </Page>
  );
}
